module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-bar-right-767d3257.svg";